import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Row,
  Col,
  Modal,
} from 'antd';

import i18n from '../../config/i18n';

const style = {
  img: {
    maxWidth: '90%',
    height: '70%',
  },
  imgContainer: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '200px',
  },
};

class ExerciseView extends Component {
  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      img: PropTypes.string,
      step: PropTypes.arrayOf(PropTypes.string),
    })),
  };

  static defaultProps = {
    list: [],
  };

  showModal = (e) => {
    const {
      title,
      description,
      img,
      steps,
    } = e;

    Modal.info({
      title,
      content: (
        <div>
          <p>{description}</p>
          <img style={style.img} alt={title} src={img} />
          <ol>
            {steps.map((step, index) => (<li key={index.toString()}>{step}</li>))}
          </ol>
        </div>
      ),
      onOk() {},
      centered: true,
      width: 600,
    });
  };

  render() {
    const { list } = this.props;
    return (
      <div>
        <Row>
          <Col xs={{ span: 24 }} md={{ span: 18, offset: 6 }}>
            <h1>{i18n.t('reduceFallRiskExercise')}</h1>
          </Col>
        </Row>
        <Row>
          {list.map(exercise => (
            <Col
              key={exercise.id}
              span={8}
            >
              <Card
                hoverable
                cover={
                  <div style={style.imgContainer}>
                    <img style={style.img} alt={exercise.title} src={exercise.img} />
                  </div>
                }
                onClick={() => { this.showModal(exercise); }}
              >
                <Card.Meta
                  title={exercise.title}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    );
  }
}

export default ExerciseView;



// WEBPACK FOOTER //
// ./src/components/fpp/ExerciseView.js